module.exports = __webpack_public_path__ + "static/media/1989_Population_totalRate.d69da5c8.png";